export default "__VITE_ASSET__CUHh6Xkd__"